export function sanitizeLoginRedirectPath(rawPath: string | null | undefined): string | null {
  if (!rawPath) {
    return null;
  }

  if (!rawPath.startsWith('/') || rawPath.startsWith('//')) {
    return null;
  }

  try {
    const origin =
      typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
    const url = new URL(rawPath, origin);
    if (url.origin !== origin || url.pathname === '/login') {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function resolveLoginRedirectPath(
  search: string,
  fallbackPath: string,
): string {
  const redirectPath = sanitizeLoginRedirectPath(new URLSearchParams(search).get('from'));
  return redirectPath ?? fallbackPath;
}
